import { somervilleConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function SomervillePage() {
  return <CityPageTemplate config={somervilleConfig} />;
}